/**
 * entropion.ts
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import EntropionVue from './views/entropion/entropion.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/entropion.js'

async function goApp() {
    const app = createApp(EntropionVue)
    registerPlugins(app, 'entropion')
    await store.dbinit()
    app.mount('#app')
}

goApp()
